import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
// eslint-disable-next-line
import sensors from './sensors';
// eslint-disable-next-line
import holeList from './hole/holeList';
// eslint-disable-next-line
import DashboardStore from './dashboard/DashboardStore';
// eslint-disable-next-line
import TaskBoardStore from './task/board/TaskBoardStore';
// eslint-disable-next-line
import SettingsStore from './settings/SettingsStore';
// eslint-disable-next-line
import UsersStore from './users/UsersStore';
// eslint-disable-next-line
import MessagesStore from './messages/MessagesStore';
// eslint-disable-next-line
import CoursesStore from './courses/CoursesStore';
// eslint-disable-next-line
import CourseSetupStore from './courses/CourseSetupStore';
// eslint-disable-next-line
import StationsStore from './stations/StationsStore';
// eslint-disable-next-line
import AlertsStore from './alerts/AlertListStore';
// eslint-disable-next-line
import SensorProvisioningStore from './provisioning/SensorProvisioningStore';
// eslint-disable-next-line
import KnowledgeBaseStore from './knowledgeBase/KnowledgeBaseStore';
// eslint-disable-next-line
import CatalogsStore from './catalogs/CatalogsStore';

import {
  getFacilityTypes,
} from '@/api/index';

import { isEmpty } from 'lodash';

Vue.use(Vuex);

const initialState = () => ({
  logged: false,
  course: {},
  user: {},
  userCourses: [],
  fullMenu: [],
  menuPolicy: [],
  prevRoute: {},
  backgrounIndex: 0,
  flag: null
});

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: { ...initialState() },
  mutations: {
    setCourse(state, course) {
      state.course = course;
    },
    setFlag(state, flag) {
      state.flag = flag;
    },
    setUser(state, user) {
      state.user = user;
    },
    setLogged(state, logged) {
      state.logged = logged;
    },
    setMenuPolicy(state, menuPolicy) {
      state.menuPolicy = menuPolicy;
    },
    setPrevRoute(state, prevRoute) {
      state.prevRoute = prevRoute;
    },
    setUserCourses(state, courses) {
      state.userCourses = courses;
    },
    setFullMenu(state, menu){
      state.fullMenu = menu
    },
    addUserCourse(state, course) {
      state.userCourses = [...state.userCourses, course];
    },
    setBackgrounIndex(state, index) {
      state.backgrounIndex = index;
    },
    reset(state) {
      Object.assign(state, { ...initialState() });
    },
  },
  actions: {
    reset(context) {
      context.commit('reset');
    },

    changeBackground({ commit, state }) {
      if (!isEmpty(state.course)) {
        if (state.course.background_images.length > 0) {
          let bgImage = document.getElementById('bg-image');
          bgImage.classList.add('bg-fadeOut')
          setTimeout(() => {
            bgImage.classList.remove('bg-fadeOut')
            bgImage.classList.add('bg-fadeIn')
            bgImage.style.backgroundImage =
              `linear-gradient(to top left, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)), url("${state.course.background_images[state.backgrounIndex].image_url}") `;
            setTimeout(() => {
              bgImage.classList.remove('bg-fadeIn')
            }, 2000);
          }, 1000);
          if ((state.course.background_images.length - 1) > state.backgrounIndex) {
            commit('setBackgrounIndex', state.backgrounIndex + 1);
          } else {
            commit('setBackgrounIndex', 0);
          }
        }else{
          if (state.course.facility_type && state.course.facility_type.web_image_url){
            let bgImage = document.getElementById('bg-image');
            bgImage.style.backgroundImage =
              `linear-gradient(to top left, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)), url("${state.course.facility_type.web_image_url}") `;
          }else if (state.course.facility_type && state.course.facility_type.type_id){
            //try to get the facility type information if it's not up to date
            getFacilityTypes().then((resp) => {
              if (resp.facility_types && resp.facility_types.length) {
                const facility_type = resp.facility_types.find((item) => item.type_id === state.course.facility_type.type_id);
                if(facility_type){
                  //this.updateCourse(course);
                  if(facility_type.web_image_url){
                    let bgImage = document.getElementById('bg-image');
                    bgImage.style.backgroundImage =
                      `linear-gradient(to top left, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)), url("${facility_type.web_image_url}") `;
                  }
                }
              } else {
                // No facility types available
              }
            })
          }
        }
      }

    },

    updateUserCourse({ commit, state }, course) {
      const idx = state.userCourses.findIndex((c) => c.course_id === course.course_id);
      if (idx > -1) {
        let courses =  state.userCourses;
        courses[idx] = course;
        commit('setUserCourses', [...courses]);
        
        if (state.course.course_id === course.course_id) {
          commit('setCourse', course);
        }
      }
    },

  },
  modules: {
    sensors,
    holeList,
    Dashboard: DashboardStore,
    TaskBoard: TaskBoardStore,
    Settings: SettingsStore,
    Users: UsersStore,
    Messages: MessagesStore,
    Courses: CoursesStore,
    CourseSetup: CourseSetupStore,
    Stations: StationsStore,
    Alerts: AlertsStore,
    SensorProvisioning: SensorProvisioningStore,
    KnowledgeBase: KnowledgeBaseStore,
    Catalogs: CatalogsStore,
  },
});
